enum CardUsageLimitStatus {
  BLOCKED = 'BLOCKED',
  NOTBLOCKED = 'NOTBLOCKED',
}

export default CardUsageLimitStatus;
